<template>
    <v-dialog
        v-model="isOpen"
        max-width="350"
        @click:outside.prevent="$emit('closeModal')"
    >
        <v-card class="pa-5">
            <h3 class="text-center">New task</h3>
            <v-layout class="d-flex flex-column">
                <v-flex>
                    <v-radio-group v-model="radioValue" @change="clearRadioData">
                        <v-flex>
                            <v-radio label="From a checklist" value="checklist"></v-radio>
                            <v-autocomplete
                                :items="hrRoles | sortByValue"
                                :disabled="radioValue !== 'checklist'"
                                v-model="hrRoleId"
                                item-text="value"
                                item-value="id"
                                placeholder="Select from checklist"
                                @change="setRequiredField(hrRoleId)"
                                return-object
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex>
                            <v-radio label="From a single template" value="template"></v-radio>
                            <v-autocomplete
                                :items="taskTemplates | sortByValue"
                                :disabled="radioValue !== 'template'"
                                v-model="selectedTaskTemplate"
                                item-text="value"
                                item-value="id"
                                placeholder="Select a template"
                                @change="setRequiredField(selectedTaskTemplate)"
                                return-object
                                class="text-uppercase"
                            >
                                <template v-slot:item="{item}">
                                    <span class="text-uppercase">{{item.value}}</span>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-radio-group>
                    <div style="margin-top: -20px; margin-bottom: 20px;">
                        <h4 class="ma-0 mb-1">
                            Link an Employee
                            {{isEmployeesRequired ? '*' : ''}}
                        </h4>
                        <v-autocomplete
                            v-model="linkedTo"
                            :items="employees"
                            item-text="fullName"
                            item-value="id"
                            dense
                            solo
                            lighten-1
                            placeholder="Start typing a name"
                            height="30px"
                            style="width: 100%;"
                            class="font-weight-regular mr-5"
                            return-object
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="selection-text-style">{{ item.fullName }}</span>
                                <span
                                    v-if="index === 1"
                                    class="grey--text caption"
                                >(+{{ linkedTo.length - 1 }} others)</span>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div>
                        <v-menu
                            v-model="dueDatePickerStatus"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="Date.formatDate([dueDate])"
                                    label="Due date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker first-day-of-week="1" v-model="dueDate" @input="dueDatePickerStatus = false"></v-date-picker>
                        </v-menu>
                    </div>
                </v-flex>
                <v-flex class="align-center justify-space-around d-flex">
                    <v-btn color="error" @click="$emit('closeModal')">
                        Cancel
                    </v-btn>
                    <v-btn @click="validateForm">Create</v-btn>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import INTERVALS from '@/constatns/intervalTypes'
  import { sortArrayObObjByField } from '../../../common/functions'

  export default {
    props: ['isOpen', 'closeModal'],
    name: 'hrTaskFormPopup',
    data: () => ({
      radioValue: 'checklist',
        hrRoleId: null,
      linkedTo: null,
      selectedTaskTemplate: null,
      dueDatePickerStatus: false,
      dueDate: new Date().toISOString().substr(0, 10),
      isEmployeesRequired: false
    }),
    computed: {
      ...mapGetters({
        hrRoles: 'getHrRoles',
        employees: 'getEmployeesSorted',
        taskTemplates: 'getTaskTemplates'
      })
    },
    methods: {
      clearRadioData () {
        this.hrRoleId = null
        this.selectedTaskTemplate = null
      },
      setRequiredField (checkedField) {
        if (checkedField && checkedField.additional) {
          this.isEmployeesRequired = checkedField.additional.hasHrRenewableTaskTemplate
        }
      },
      validateForm () {
        if (!(this.hrRoleId || this.selectedTaskTemplate)) {
          this.$store.dispatch('showAlert', {
            text: 'Please select all values',
            type: 'error'
          })
          return
        }
        if (this.isEmployeesRequired && !this.linkedTo) {
          this.$store.dispatch('showAlert', {
            text: 'Link an Employee is required field!',
            type: 'error'
          })
          return
        }
        this.formSubmit()
      },
      async formSubmit () {
        const params = {
            hrRoleId: this.hrRoleId ? this.hrRoleId.id : null,
          linkedTo: this.linkedTo ? this.linkedTo.id : null,
          taskTemplateId: this.selectedTaskTemplate ? this.selectedTaskTemplate.id : null,
          groupId: this.$store.getters.getUserActiveGroup,
          dueDate: this.dueDate
        }
        await this.$store.dispatch('createHrTask', params)
        this.$emit('closeModal')
        this.$store.dispatch('showAlert', {
          text: 'Success!',
          type: 'success'
        })
      }
    },
    async mounted () {
      const params = {
        getAll: true,
        itemsPerPage: 1000,
        pageNumber: 1,
        interval: INTERVALS.HR
      }
      await this.$store.dispatch('fetchHrRoles')
      await this.$store.dispatch('fetchTaskTemplates', params)
      await this.$store.dispatch('fetchEmployees', params)
    },
    filters: {
      sortByValue: function (arrayOfObj) {
        return sortArrayObObjByField(arrayOfObj, 'value')
      }
    }
  }
</script>

<style>
</style>
